import { BaseButton, Button, Icon, ITextFieldProps, Link, MessageBarType, TextField } from 'office-ui-fabric-react';
import * as queryString from 'query-string';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Dispatch } from 'redux';
import { loginToken } from '../../../redux/Actions/Security/ActionCreators';
import { ISecurityPayload, LoginMode } from '../../../redux/Actions/Security/ActionTypes';
import { IRootState } from '../../../redux/Reducers/RootReducer';
import Api from '../../Api';
import Auth from '../Auth';
import '../Auth.css';
import './Login.css';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    saveToken: (param: ISecurityPayload) => dispatch(loginToken(param))
  };
};

export interface ILoginState {
  username?: string;
  password?: string;
  token?: string;
  isProcessing: boolean;
  isAutoLogin: boolean;
  goTo?: string;
  message?: string;
}

function mapStateToProps(state: IRootState, ownProps: any) {
  return { security: state.securityState.security };
}

class Login extends React.PureComponent<any, ILoginState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isProcessing: false,
      isAutoLogin: false
    };

    this.login = this.login.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  public componentDidMount() {
    const query = queryString.parse(this.props.location.search);

    const user = query.user ? `${query.user}` : undefined;
    const pwd = query.pwd ? `${query.pwd}` : undefined;
    const goTo = query.goTo ? `${query.goTo}` : undefined;

    if (query.user && query.pwd) {
      this.setState({ username: user, password: pwd, goTo: goTo, isAutoLogin: true }, () => {
        this.login();
      });
    } else {
      const { security } = this.props;
      const hasMsg = !!(security && security.message);
      this.setState({ goTo: goTo, isAutoLogin: false, message: hasMsg ? security.message : undefined });
    }
  }

  public render(): JSX.Element {
    if (this.state.isAutoLogin) {
      return <></>;
    }

    return (
      <Auth
        buttonText={'Login'}
        buttonDisabled={this.state.isProcessing || !this.state.username || !this.state.password}
        buttonOnClick={this.login}
        isProcessing={this.state.isProcessing}
        messageText={this.state.message}
        messageType={MessageBarType.blocked}
        onKeyPress={this.onKeyPress}
      >
        <TextField
          className="inputField"
          placeholder="Username"
          ariaLabel="Please enter username here"
          defaultValue={this.state.username ? this.state.username : undefined}
          disabled={this.state.isProcessing}
          deferredValidationTime={50}
          validateOnLoad={false}
          onGetErrorMessage={this.getErrorMessage}
          // tslint:disable-next-line:jsx-no-lambda
          onChange={(ev, input) => {
            this.setState({ username: input ? input : '' });
          }}
          prefix="Contact"
          onRenderPrefix={this.onRenderPrefix}
        />
        <TextField
          className="inputField"
          type={'password'}
          placeholder="Password"
          ariaLabel="Please enter password here"
          defaultValue={this.state.password ? this.state.password : undefined}
          disabled={this.state.isProcessing}
          deferredValidationTime={50}
          validateOnLoad={false}
          onGetErrorMessage={this.getErrorMessage}
          // tslint:disable-next-line:jsx-no-lambda
          onChange={(ev, input) => {
            this.setState({ password: input ? input : '' });
          }}
          prefix="AzureKeyVault"
          onRenderPrefix={this.onRenderPrefix}
        />
        <div style={{ textAlign: 'end' }}>
          <Link href="forgot" styles={{ root: { fontSize: '.85em' } }}>
            Forgot Password?
          </Link>
        </div>
      </Auth>
    );
  }

  private onRenderPrefix(props: ITextFieldProps | undefined): JSX.Element {
    return props ? <Icon iconName={props.prefix} /> : <></>;
  }

  private getErrorMessage(value: string): string | undefined {
    return !value ? 'Required' : undefined;
  }

  private onKeyPress(ev: React.KeyboardEvent<HTMLDivElement | HTMLAnchorElement | HTMLButtonElement | BaseButton | Button>): void {
    if (ev.key === 'Enter' && !this.state.isProcessing) {
      console.log('Enter!');
      this.login();
    }
  }

  private login(): void {
    this.setState({ isProcessing: true });

    const request = {
      username: this.state.username,
      password: this.state.password,
      isPasswordEncrypted: this.state.isAutoLogin
    };

    Api.post('auth', request)
      .then(response => {
        const token: string = `Bearer ${response.data.token}`;
        const payload: ISecurityPayload = {
          username: this.state.username,
          password: this.state.password,
          token,
          loginMode: this.state.isAutoLogin ? LoginMode.EMBEDDED : LoginMode.NORMAL
        };

        this.props.saveToken(payload);

        this.state.goTo ? this.props.history.push(this.state.goTo) : this.props.history.push('/search');
      })
      .catch(error => {
        const message = error.response
          ? `Request failed with status code ${error.response.data.status}: ${error.response.data.message}`
          : error.toJSON().message;

        this.setState({
          isProcessing: false,
          message: message
        });
      });
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Login) as any);
